import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { membersList, teamMembers } from "actions/members";
import ContentHeader from "../components/ContentHeader";
import Table from "./components/Table";
import Filter from "../components/Filter";
import EditMember from "./components/EditMember";
import AddMember from "./components/AddMember";
import Button, { SIZE } from "components/Button";
import Checkbox from "components/Checkbox";
import sortAscending, { sortDescending } from "utils/sortData";

import styles from "./Members.module.scss";

const Members = ({ setFullWidth }) => {
  const dispatch = useDispatch();
  const [team, setTeam] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState([]);
  const [filterResult, setFilterResult] = useState([]);
  const [employeesPhotos, setEmployeesPhotos] = useState(new Map());
  const [currentScreen, setCurrentScreen] = useState("");
  const [memberDetails, setMemberDetails] = useState("");
  const [checked, setChecked] = useState(true);
  const [sorted, setSorted] = useState(false);
  const [currentColumn, setCurrentColumn] = useState("first_name");

  const membersData = useSelector((state) => state.members);

  useEffect(() => {
    dispatch(teamMembers);
  }, [dispatch]);

  useEffect(() => {
    membersData?.groups && setTeam(membersData.groups);
    membersData?.scheduleGroup && setSchedule(membersData.scheduleGroup);
  }, [membersData]);

  useEffect(() => {
    const result = (checked ? membersData?.team : membersData?.allTeam)?.filter(
      ({ first_name, last_name }) => {
        return selectedMembers.includes(first_name + " " + last_name);
      }
    );

    setFilterResult(result);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMembers]);

  const handleChange = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    if (!checked) {
      dispatch(membersList(0, 0));
      setFilterResult(membersData?.allTeam);
    } else {
      dispatch(membersList(1, 0));
      setFilterResult(membersData?.team);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked, dispatch]);

  const sortColumn = (columnName) => {
    if (currentColumn !== columnName) {
      setSorted(false);
      setCurrentColumn(columnName);
    }

    setSorted((prev) => !prev);

    (filterResult?.length ? filterResult : membersData?.team).sort((a, b) => {
      if (currentColumn !== columnName) {
        return sortAscending(a, b, columnName);
      } else {
        return sorted
          ? sortDescending(a, b, columnName)
          : sortAscending(a, b, columnName);
      }
    });

    return membersData?.team;
  };

  useEffect(() => {
    currentScreen === "add" || currentScreen === "edit"
      ? setFullWidth(true)
      : setFullWidth(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentScreen]);

  return (
    <div>
      {currentScreen === "" && (
        <>
          <Button
            size={SIZE.MIDDLE}
            className={styles.add_button}
            onClick={() => setCurrentScreen("add")}
          >
            Add Team Member
          </Button>

          <ContentHeader title="Team Members" />

          <Filter
            team={team}
            selectedTeams={selectedTeams}
            setSelectedTeams={setSelectedTeams}
            selectedMembers={selectedMembers}
            setSelectedMembers={setSelectedMembers}
            employeesPhotos={employeesPhotos}
            setEmployeesPhotos={setEmployeesPhotos}
            schedule={schedule}
            selectedSchedule={selectedSchedule}
            setSelectedSchedule={setSelectedSchedule}
            className={styles.filter}
            checkbox={
              <Checkbox
                id="filter"
                label="Show only active users"
                value={checked}
                onChange={handleChange}
              />
            }
          />

          <Table
            data={filterResult?.length ? filterResult : membersData?.team}
            photos={employeesPhotos}
            setCurrentScreen={setCurrentScreen}
            setMemberDetails={setMemberDetails}
            sortColumn={sortColumn}
          />
        </>
      )}

      {currentScreen === "edit" && (
        <EditMember
          memberDetails={memberDetails}
          setCurrentScreen={setCurrentScreen}
        />
      )}

      {currentScreen === "add" && (
        <AddMember memeberDetails={""} setCurrentScreen={setCurrentScreen} />
      )}
    </div>
  );
};

export default Members;
